export default __webpack_public_path__ + "static/media/supplychain.48ba1039.svg";